import React from "react";
import TopicsPage from "../../TopicsPage";
import OnboardingNavigation from "../OnboardingNavigation";
import { StepHeader } from "./index";

const Topics = props => (
  <div>
    <StepHeader>
      Which of the following issues are of most concern to your business?
    </StepHeader>

    <TopicsPage
      {...props}
      renderSubmit={handleSubmit => (
        <OnboardingNavigation {...props} goForward={handleSubmit} />
      )}
    />
  </div>
);

export default Topics;



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/Topics.js